import { render, staticRenderFns } from "./DashboardVideoCall.vue?vue&type=template&id=d750b314"
import script from "./DashboardVideoCall.vue?vue&type=script&lang=js"
export * from "./DashboardVideoCall.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports